module.exports = __webpack_public_path__ + "img/21.b99976de.jpg";